import { deleteAchDepositAsync } from '../../../../../API/order/escrow/EscrowAPI';
import { createAsyncSlice } from '../../../../createAsyncSlice';

export const { slice: deleteAchDepositSlice, asyncAction: deleteAchDepositAction } = createAsyncSlice(
  'deleteAchDepositSlice',
  deleteAchDepositAsync
);
